// extracted by mini-css-extract-plugin
export default {"modal":"modal___F4aNR","modalContent":"modal-content___iktb8"};